import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/advantures/MainBlooming.webp"; 

import TorontoFlowerMarket from "../../../assets/img/blog/advantures/TorontoFlowerMarket.webp"; 
import FieldstoneBarn from "../../../assets/img/blog/advantures/FieldstoneBarn.webp"; 
import Hereward from "../../../assets/img/blog/advantures/Hereward.webp"; 
import RoundsRanch from "../../../assets/img/blog/advantures/RoundsRanch.webp"; 
import GivingPlace from "../../../assets/img/blog/advantures/GivingPlace.webp"; 

const JUNE_ADVENTURES = [
  {
    farms: [
      {
        name: "1. Toronto Flower Market",
        img: TorontoFlowerMarket,
        subTitle: "Urban blooms meet community charm.",
        description: "If you’re a flower lover, the Toronto Flower Market is your dream day out. Held monthly from spring through fall, this open-air market highlights the best of Ontario-grown flowers in every shade imaginable. Meet local growers, discover rare floral varieties, and bring home a bouquet (or three). It’s not just a market—it’s a celebration of beauty and botanical creativity.",
        location: "1001 Queen St W, Toronto, ON",
        website: "torontoflowermarket.ca",
        webUrl: "https://www.torontoflowermarket.ca/",
        details: [
          { label: "Dates", value: "Saturdays — June 14, July 12, August 16, September 13, October 11" },
          { label: "Time", value: "10:00 AM – 3:00 PM" },
          { label: "Admission", value: "Free" },
          { label: "Good to Know", value: "Wheelchair accessible, Street parking available, TTC-friendly, Furry friends are welcome!" }
        ]
      },  
      {
        name: "2. The Fieldstone Barn",
        img: FieldstoneBarn,
        subTitle: "Rustic charm meets flower-filled bliss.",
        description: "Located in scenic Elora, The Fieldstone Barn is a historic venue and flower farm perfect for a summer day trip. Known for its iconic sunflower fields and elegant barn, it’s a top pick for weddings, events, and family visits. Wander the fields, soak in the natural beauty, and don’t forget to explore the charming town of Elora nearby.",
        location: "7450 Middlebrook Rd, Elora, ON",
        website: "thefieldstonebarn.com",
        webUrl: "https://www.thefieldstonebarn.com/",
        details: [
          { label: "Good to Know", value: "Pet-friendly!" }
        ]
      },
      {
        name: "3. Hereward Farms",
        img: Hereward,
        subTitle: "Lavender dreams and countryside calm.",
        description: "Surrounded by 400,000 sunflowers and 6,000 lavender plants, Hereward Farms provides a peaceful haven. At the Lavender Lounge + Café, you can relax with local treats, explore a boutique full of lavender-infused products, and take part in seasonal events designed to engage all your senses.",
        location: "141051 Side Rd 15, East Garafraxa, ON",
        website: "herewardfarm.com",
        webUrl: "https://www.herewardfarm.com/",
        details: [
          { label: "Admission", value: "$10 (Children under 5 are free)" },
          { label: "Things to Do", value: "Sip & Savor: Wednesday to Saturday, 10 AM – 4 PM | Lavender Boutique: Open daily | Seasonal Events: July–September peak bloom; includes “Sip, Savour & Stroll”" }
        ]
      },
      {
        name: "4. Rounds Ranch",
        img: RoundsRanch,
        subTitle: "Big fun on the farm for the whole family.",
        description: "With over 25 activities, Rounds Ranch is a family-friendly paradise. From adorable baby animals to thrilling slides and bubble bashes, there’s something for everyone. Whether it’s your first visit or an annual tradition, the energy and excitement here are unmatched. Whether you’re planning a family day out, school trip, birthday party, corporate picnic, or day camp, Rounds Ranch is the perfect place to create enduring memories.",
        location: "1922 County Rd 92, Elmvale, ON",
        website: "roundsranch.com",
        webUrl: "https://roundsranch.com/",
        details: [
          { label: "June Highlights", value: "Spring Fun: Saturdays in June | Members-Only Day: June 21 | Ranch Kickoff: June 27–June 28" },
          { label: "Seasonal Preview", value: "Baby animals (June) | Wildflowers (July) | Sunflowers (August) | Pumpkin Mania (Fall) | Halloween Extravaganza (October)" }
        ]
      },
      {
        name: "5. The Giving Place",
        img: GivingPlace,
        subTitle: "A tranquil farm rooted in community and care.",
        description: "This peaceful gem in Mount Albert is all about mindfulness, connection, and giving back. With meandering walking paths, special wellness events, and stunning views, even before sunflower season, the farm is a place to reset and recharge. A portion of the proceeds supports charitable initiatives, making every visit feel extra good.",
        location: "19618 E Townline, Mount Albert, ON",
        website: "thegivingplace.ca",
        webUrl: "https://thegivingplace.ca/",
        details: [
          { label: "Upcoming Activities", value: "Outdoor Tabata Pilates: Fridays in June, 8:45 – 9:45 AM | Yoga in the Lavender Fields: June 14 & 29 ($40) | A Night of 1000 Candles: Sat, June 28, 12 AM – 1 AM ($50)" }
        ]
      }
    ]
  },

];

export default function BloomingAdventures() {
  return (
    <div className={styles.page}>

      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Blooming Adventures</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti Team</span>
        <span className={styles["sep"]}>•</span>
        <span>Posted today</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>Blooming Adventures & Countryside Charm in June</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="June Blooms Hero"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>June is when Ontario truly comes alive!</strong><br />
        From the first vibrant bursts of the flower markets to the beginning of the lavender season, there’s no better time to explore the countryside. Whether you’re looking for the perfect photo op or a peaceful escape into nature, these spots are a must-visit this month.</p>
      </div>

      <div className={styles["jump-links"]}>
        {JUNE_ADVENTURES.map((region, idx) => (
          <React.Fragment key={region.id}>
            <a href={`#${region.id}`}>{region.region}</a>
            {idx < JUNE_ADVENTURES.length - 1 && <span> | </span>}
          </React.Fragment>
        ))}
      </div>

      {JUNE_ADVENTURES.map((region) => (
        <div key={region.id} id={region.id}>
          <h2 className={styles["region-title"]}>{region.region}</h2>
          <hr className={styles["region-divider"]} />
          
          {region.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                <p><strong>{farm.subTitle}</strong></p>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Website:</span><br />
                  <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                    {farm.website}
                  </a>
                </li>
                {farm.details && farm.details.map((detail, dIdx) => {
                  const isHighlight = ["Good to Know", "Things to Do", "June Highlights", "Seasonal Preview", "Upcoming Activities"].includes(detail.label);
                  if (isHighlight) {
                    let contentItems = [];
                    if (detail.value.includes('|')) {
                      contentItems = detail.value.split('|').map(s => s.trim());
                    } else if (detail.label === "Good to Know" && detail.value.includes(',')) {
                      contentItems = detail.value.split(',').map(s => s.trim());
                    } else {
                      contentItems = [detail.value];
                    }

                    return (
                      <li key={dIdx} className={styles["highlight-detail"]}>
                        <span className={styles["highlight-label"]}>{detail.label}</span>
                        <div className={styles["highlight-content"]}>
                          <ul className={styles["highlight-list"]}>
                            {contentItems.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    );
                  }
                  return (
                    <li key={dIdx} className={styles["details-item"]}>
                      <span className={styles["details-label"]}>{detail.label}:</span> {detail.value}
                    </li>
                  );
                })}
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}

      <div className={styles["lead-section"]}>
        <h2 className={styles["title"]} style={{ fontSize: '2rem', marginTop: '3rem' }}>Make June Count</h2>
        <p>Ontario is bursting with life and color this time of year. Whether you’re picking peonies, wandering through lavender fields, or soaking up sunshine at a flower market, these destinations deliver the perfect blend of nature, nourishment, and joy.</p>
        <p>🌞 So grab your sunhat, charge your camera, and let Farmciti guide your next blooming adventure across Ontario.</p>
      </div>
    </div>
  );
}
